import api from '../services/api';

// کش ساده برای جلوگیری از درخواست‌های تکراری
let cachedCss = null;

export function injectFontCss(css) {
  if (!css) return;
  let el = document.getElementById('kadolar-font-css');
  if (!el) {
    el = document.createElement('style');
    el.id = 'kadolar-font-css';
    document.head.appendChild(el);
  }
  el.textContent = css;
}

// دریافت CSS پیش‌فرض فونت بخش‌ها از بک‌اند و تزریق آن به صفحه
export async function loadAndInjectFontCss() {
  if (cachedCss !== null) {
    injectFontCss(cachedCss);
    return cachedCss;
  }
  try {
    const resp = await api.get('/settings/fonts/');
    const css = (resp && resp.data && resp.data.css) || '';
    cachedCss = css;
    injectFontCss(css);
    return css;
  } catch (e) {
    return '';
  }
}
